import React, { createContext, useState, useEffect } from 'react';
 
export const UserContext = createContext();
 
export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    const storedUserName = localStorage.getItem('userName');
    if (storedUserId && storedUserName) {
      setUserId(storedUserId);
      setUserName(storedUserName);
    }
  }, []);

  const setUserData = ({ sgid, user_name }) => {
    setUserId(sgid);
    setUserName(user_name);
    localStorage.setItem('userId', sgid);
    localStorage.setItem('userName', user_name);
  };

  const clearUserData = () => {
    setUserId('');
    setUserName('');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
  };

  return (
    <UserContext.Provider
      value={{
        userId,
        setUserData,
        userName,
        clearUserData
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
